import algolia from 'algoliasearch';

const appId = process.env.REACT_APP_ALGOLIA_APP_ID || '';
const apiKey = process.env.REACT_APP_ALGOLIA_API_KEY || '';

export const algoliaIndex = algolia(appId, apiKey);

export const storeIndex = algoliaIndex.initIndex(process.env.REACT_APP_ALGOLIA_STORE_INDEX || '');

export const itemIndex = algoliaIndex.initIndex(process.env.REACT_APP_ALGOLIA_ITEM_INDEX || '');
